export default __webpack_public_path__ + "SpringbukBlackLogo.bfbe9b8cb420a3d19f22d2a0f0e2bd9c.png";